module.exports = __webpack_public_path__ + "static/media/screenshot-section-add-todo.4710c164.png";